










































import {Component, Vue} from "vue-property-decorator";
import DefaultTemplate from "@/components/templates/default/DefaultTemplate.vue";
import authService from "@/components/domains/auth/authService";
import PasswordlessService from "@/components/domains/auth/passwordlessService";
import {AuthPolicy, formatRetireDate, toAuthError} from "@/components/domains/auth/authPolicy";

/** Sign-in for accounts that have no email address. */
@Component({
  components: {DefaultTemplate}
})
export default class UsernameLogin extends Vue {
  name = "UsernameLogin";

  policy: AuthPolicy | null = null;
  username = '';
  password = '';
  error = '';
  useEmail = false;
  submitting = false;

  get retireNotice(): string {
    const date = this.policy ? formatRetireDate(this.policy.noEmailPasswordLoginRetiresAt) : '';
    return date ? `この入り口は${date}で終了します。ログインしたら、メールアドレスを設定してください。` : '';
  }

  mounted(): void {
    PasswordlessService.loadPolicy({fresh: true}).then((p) => (this.policy = p));
  }

  async submit(): Promise<void> {
    this.error = '';
    this.useEmail = false;
    if (!this.username.trim() || !this.password) {
      this.error = 'ユーザー名とパスワードを入力してください。';
      return;
    }
    this.submitting = true;
    try {
      await PasswordlessService.loginWithUsername(this.username.trim(), this.password);
    } catch (e) {
      const err = toAuthError(e, 'ログインに失敗しました。');
      this.error = err.message;
      this.useEmail = err.reason === 'NO_EMAIL_USE_EMAIL_LOGIN';
      this.submitting = false;
      return;
    }
    // Same post-login path as the password login.
    await authService.authMe();
    this.submitting = false;
    this.$router.push('/');
  }
}
